export const getConstructionNumberIds = () => {
    switch (window.__ENVIRONMENT_DETAILS__.areaId) {
        case 'a0i2X00000D6143QAB':
            // Cloudvillage area
            return [
                'a083O0000000kDoQAI',
                'a083O0000000kEmQAI',
                'a083O0000000kEHQAY',
                'a083O0000000kDwQAI',
                'a083O0000000kEFQAY',
                'a083O0000000kDeQAI',
                'a083O0000001V6JQAU',
                'a083O000001FaG0QAK',
                'a082X00001BuqrmQAB',
                'a083O0000000kIXQAY',
                'a083O0000000kISQAY',
                'a083O0000000kITQAY',
                'a083O0000000kIOQAY',
            ];
        case 'a0i3O000002cuSzQAI':
            // Netherlands area
            return [
                'a083O000003qMauQAE',
                'a083O000003qMYuQAM',
                'a083O0000045ZIBQA2',
                'a083O000003qMYfQAM',
                'a083O000003qMY6QAM',
            ];
        case 'a0iw0000008QvIVAA0':
            // Hoef en haag
            return [
                'a087R00001FPo8JQAT',
                'a082X00001Bn34JQAR',
                'a087R00001FPoAhQAL',
                'a082X00001BnIjiQAF',
                'a087R00001FPqhCQAT',
                'a087R00001FPuMOQA1',
                'a087R00001FPpvlQAD',
                'a087R00001FPq6PQAT',
                'a087R00001FPq73QAD',
                'a087R00001FPq7SQAT',
                'a087R00001FPuosQAD',
            ];
    }

    return [];
};
